/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_4_DescInputs */

const en_mk_loop_4_desc = /** @type {(inputs: Mk_Loop_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`test · build · lint · http · file · screenshot. Output is scrubbed of secrets, then uploaded as evidence.`)
};

const id_mk_loop_4_desc = /** @type {(inputs: Mk_Loop_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`test · build · lint · http · file · screenshot. Keluaran diredaksi dari rahasia, lalu diunggah sebagai bukti.`)
};

/**
* | output |
* | --- |
* | "test · build · lint · http · file · screenshot. Output is scrubbed of secrets, then uploaded as evidence." |
*
* @param {Mk_Loop_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_4_desc = /** @type {((inputs?: Mk_Loop_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_4_desc(inputs)
	return en_mk_loop_4_desc(inputs)
});